import  React  from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';

// MUI
import { ThemeProvider } from '@mui/material';
import { appTheme } from './themes/theme';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

// Apollo
import { ApolloClient, InMemoryCache, ApolloProvider, createHttpLink } from '@apollo/client'
import { fromPromise, ApolloLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import { GET_REFRESH_TOKEN_MUTATION } from './graphql/authentication/authentication.mutation';
import Pages from './pages/pages';
import reportWebVitals from './reportWebVitals';
import { LocalizationProvider } from '@mui/x-date-pickers';

const getNewToken = () => {
  const refreshToken = sessionStorage.getItem("asiAdminRefreshToken");
  return apolloClient.mutate({ 
    mutation: GET_REFRESH_TOKEN_MUTATION, 
    variables: {
      refreshToken
  } }).then((response) => {
    // extract your accessToken from your response data and return it
    const { token, refreshToken } = response.data.refreshToken;
    sessionStorage.setItem("asiAdminRefreshToken", refreshToken);
    sessionStorage.setItem("asiAdminAuthToken", token);
    return token;
  });
};

const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      
      for (let err of graphQLErrors) {
        
        switch (err.message) {
          case "Authentication credentials were not provided":
            return fromPromise(
              getNewToken().catch((error) => {
                // Handle token refresh errors e.g clear stored tokens, redirect to login

                return;
              })
            )
              .filter((value) => Boolean(value))
              .flatMap((accessToken) => {
                const oldHeaders = operation.getContext().headers;
                // modify the operation context with a new token
                operation.setContext({
                  headers: {
                    ...oldHeaders,
                    authorization: `Bearer ${accessToken}`,
                  },
                });

                // retry the request, returning the new observable
                return forward(operation);
              });

          default:
            break;
        }
      }
    }
  }
);


console.log("API Endpoint:", process.env.REACT_APP_API_ENDPOINT);
const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_ENDPOINT||"https://asi-ip-application-cf69a8619182.herokuapp.com/",
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  
  const token = sessionStorage.getItem("asiAdminAuthToken");
  
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

export const apolloClient = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache()
});



ReactDOM.render(<BrowserRouter>
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={appTheme}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
        <Pages />
        </LocalizationProvider>
      </ThemeProvider>
    </ApolloProvider>
</BrowserRouter>,
document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();